import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { create, updateAction } from "../../../store/actions/CommonActions";
import ArtistForm from "../Forms/ArtistForm";
import { removeImageFromPath, uploadFileToServer } from "../Forms/FormHandler";
import { toast } from "react-toastify";

const FormModal = ({ modalConfig }) => {
  // const closeModal = setShow(false);
  const {
    validationSchema,
    apiUrl,
    closeModal,
    handleCloseModal,
    FormComponent,
    updateTitle,
    addTitle,
    showModal,
    extraProps,
    subTitle,
  } = modalConfig;
  const [relationData, setRelationData] = useState({});
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState(
    modalConfig?.initialValues ?? {}
  );
  useEffect(() => {
    if (extraProps && extraProps.relationKeys) {
      let relationElementsData = {};
      let tmpInitialValues = { ...modalConfig.initialValues };
      extraProps.relationKeys.forEach((relationItem) => {
        if (tmpInitialValues[relationItem]) {
          relationElementsData[relationItem] = {
            ...tmpInitialValues[relationItem],
          };
        }
        tmpInitialValues[relationItem] = tmpInitialValues[relationItem]?._id ?? "";
      });
      setInitialValues(tmpInitialValues);
      setRelationData(relationElementsData);
    }
  }, [extraProps]);

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      console.log(initialValues, "intalValuesss", apiUrl, values, "valuesss");
      setSubmitting(true);
      const keysToCheck = ["profile_image", "cover_image", "bannerImage", "banner", "supportingMaterialPdf", "portfolioPdf"];

      for (const [key, value] of Object.entries(values)) {
        try {
          if (keysToCheck.findIndex((k) => k === key) !== -1) {
            const oldValue = initialValues[key];
            const newValue = values[key];

            // If old had a value, new is empty/null → remove from server
            if (oldValue && !newValue) {
              console.log("Removed:", key, "old path:", oldValue);
              // Call your API here
              await removeImageFromPath(oldValue);
            }
          }
        } catch (error) {
          toast.error("Error removing file");
          console.error(error);
          setSubmitting(false);
          return;
        }
        if (value instanceof File) {
          const file = value;
          try {
            // 🔍 upload file
            const url = await uploadFileToServer(file);
            // console.log('svnioevs', url);
            values[key] = url;
          } catch (err) {
            toast.error("Error uploading file");
            console.error(err);
            setSubmitting(false);
            return; // stop submit
          }
        }
      }
      if (values?.referenceLinks && Array.isArray(values?.referenceLinks)) {
        let tmpReferenceLinks = [];
        values?.referenceLinks.forEach((link) => {
          if (link) tmpReferenceLinks.push(link);
        });
        values.referenceLinks = tmpReferenceLinks;
      }
      let response;
      if (initialValues._id) {
        response = await updateAction(`${apiUrl}/${initialValues._id}`, "", {
          ...values,
          show: initialValues?.show ?? null,
        });
      } else {
        response = await create(`${apiUrl}`, "", {
          ...values,
          show: initialValues?.show ?? null,
        });
      }
      setSubmitting(false);
      if (response?.data?.success || response?.status === 200 || response?.status === 201) {
        if (closeModal) {
          closeModal();
        }
      }
    } catch (error) {
      setSubmitting(false);
      console.error("Form submission error:", error);
    }
  };

  return (
    <Modal
      className="modal fade"
      id="formModal"
      show={showModal}
      onHide={handleCloseModal || closeModal}
    >
      <ArtistForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        handleFormSubmit={handleFormSubmit}
        closeModal={handleCloseModal || closeModal}
        FormComponent={FormComponent}
        relationData={relationData}
        updateTitle={updateTitle}
        addTitle={addTitle}
        subTitle={subTitle}
        extraProps={extraProps}
      />
    </Modal>
  );
};

export default FormModal;
